import { Container, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

import BottomNav from '@/components/BottomNav';
import SchedulePage from '@/components/Schedule/SchedulePage';
import { useEvent } from '@/contexts/EventsContext';

export default function CurrentEventSchedule() {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { active, schedule: eventSchedule } = useEvent();

  // Fall back to the active event for timing so we can explain why the schedule isn't shown.
  const event = eventSchedule?.event ?? active;
  const now = new Date();
  const submissionsEndAt = event?.submissionsEndAt ? new Date(event.submissionsEndAt) : null;
  const hasSubmissionsEnded = submissionsEndAt ? now > submissionsEndAt : false;

  // Keep showing the schedule past the event's end, until it's no longer pulled.
  if (eventSchedule && hasSubmissionsEnded) {
    return <SchedulePage eventSchedule={eventSchedule} />;
  }

  const message = (() => {
    if (!event) return t('schedule.noEvent');
    if (!hasSubmissionsEnded) {
      return t('schedule.submissionsOpen', {
        date: submissionsEndAt?.toLocaleDateString(i18n.language, {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        }),
      });
    }

    // Submissions closed and event not over, but no public schedule to show yet.
    return t('schedule.notReady');
  })();

  return (
    <Container maxWidth="xl">
      <Typography gutterBottom variant="h2" className="font-bebas">
        {message}
      </Typography>
      {isMobile && <BottomNav />}
    </Container>
  );
}
